import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { type PorschePaymentModuleSpecsFragment } from '../../../../api/fragments/PorschePaymentModuleSpecs';
import NoItemResult from '../../../../components/results/NoItemResult';
import { usePorschePaymentSettingsDrawer } from './PorschePaymentSettingsDrawer';

export type PorschePaymentSettingsEmptyListProps = {
    module: PorschePaymentModuleSpecsFragment;
};

const PorschePaymentSettingsEmptyList = ({ module }: PorschePaymentSettingsEmptyListProps) => {
    const { t } = useTranslation(['porschePaymentModuleDetails']);
    const addPorschePaymentSettingsDrawer = usePorschePaymentSettingsDrawer(module.id);

    return (
        <>
            <NoItemResult
                extra={
                    <Button onClick={addPorschePaymentSettingsDrawer.open} type="primary">
                        {t('porschePaymentModuleDetails:emptyList.paymentSettings.noData.action')}
                    </Button>
                }
                subTitle={t('porschePaymentModuleDetails:emptyList.paymentSettings.noData.message')}
            />
            {addPorschePaymentSettingsDrawer.render()}
        </>
    );
};

export default PorschePaymentSettingsEmptyList;
